export default __webpack_public_path__ + "013196595b3651aaad1614ff390e4b08.svg";